module.exports = __webpack_public_path__ + "img/ofertas-especiales-bg.864355f8.jpg";